import React from 'react';
import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <div className="side-piece">
        <h3>Ludum Dare 47 Entry</h3>
        <a href="https://ldjam.com/events/ludum-dare/47/bjorn-to-dance">https://ldjam.com/events/ludum-dare/47/bjorn-to-dance</a>
      </div>
      <div className="side-piece">
        <h3>Leaderboards on Infamy.dev</h3>
        <a href="https://infamy.dev/highscore/web?id=bjorn-to-dance">https://infamy.dev/highscore/web?id=bjorn-to-dance</a>
      </div>
      <div className="side-piece">
        <h3>Play In Browser on Itch.io</h3>
        <a href="https://creighcl.itch.io/citdev-ld-47">https://creighcl.itch.io/citdev-ld-47</a>
      </div>
    </div>
  );
}

export default App;
